<template>
  <div class='app flex-row align-items-center'>
    <div class='container'>
      <b-row class='justify-content-center'>
        <b-col md='8' sm='8'>
          <b-card no-body class='mx-4'>
            <b-card-body class='p-4' body-bg-variant='white'>
              <b-form>
                <h1>新規登録</h1>
                <p>新規にアカウントを作成します。</p>
                  <el-input class='mb-3' size='medium' type='text' placeholder='エントリーコード' name='entrycode' v-model='input.entryCode'>
                    <template slot="prepend"><i class="fas fa-passport"></i></template>
                  </el-input>
                  <el-input class='mb-3' size='medium' type='email' placeholder='メールアドレス' name='username' v-model='input.username' autocomplete='username email'>
                    <template slot="prepend"><i class="fas fa-envelope"></i></template>
                  </el-input>
                  <el-input class='mb-3' size='medium' type='password' placeholder='パスワード' name='password' v-model='input.password' autocomplete='new-password'>
                    <template slot="prepend"><i class="fas fa-unlock-alt"></i></template>
                  </el-input>
                  <el-input class='mb-3' size='medium' type='password' placeholder='パスワード（繰り返し）' name='password' v-model='input.repeatPassword' autocomplete='new-password'>
                    <template slot="prepend"><i class="fas fa-unlock-alt"></i></template>
                  </el-input>
                <!-- <b-input-group class='mb-3'>
                  <b-input-group-prepend><b-input-group-text><i class='icon-directions'></i></b-input-group-text></b-input-group-prepend>
                  <b-form-input type='text' class='form-control' placeholder='エントリーコード' name='entrycode' v-model='input.entryCode'/>
                </b-input-group>

                <b-input-group class='mb-3'>
                  <b-input-group-prepend><b-input-group-text><i class='icon-user'></i></b-input-group-text></b-input-group-prepend>
                  <b-form-input type='email' class='form-control' placeholder='メールアドレス' name='username' v-model='input.username' autocomplete='username email' />
                </b-input-group>

                <b-input-group class='mb-3'>
                      <b-input-group-prepend><b-input-group-text><i class='icon-lock'></i></b-input-group-text></b-input-group-prepend>
                      <b-form-input type='password' class='form-control' placeholder='パスワード' name='password' v-model='input.password' autocomplete='new-password' />
                </b-input-group>

                <b-input-group class='mb-3'>
                      <b-input-group-prepend><b-input-group-text><i class='icon-lock'></i></b-input-group-text></b-input-group-prepend>
                      <b-form-input type='password' class='form-control' placeholder='パスワード（繰り返し）' name='password' v-model='input.repeatPassword' autocomplete='new-password' />
                </b-input-group> -->
                <b-button variant='success' block v-on:click='register()'>アカウント登録</b-button>
              </b-form>
            </b-card-body>

            <b-modal ref='errorModal'
              centered
              title='Error'
              class='text-danger'
              :ok-only='true'
              ok-variant=danger
              header-bg-variant=danger
              size='sm'>
              <p class='my-4'>{{errorMessage}}</p>
            </b-modal>
            <b-card-footer footer-bg-variant='white' footer-border-variant='white'>
            <!-- <template slot='footer'> -->
              <b-button @click='goBack'>Back</b-button>
            <!-- </template> -->
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import { mapGetters } from 'vuex'
export default {
  name: 'Register',
  data () {
    return {
      input: {
        entryCode: '',
        username: '',
        password: '',
        repeatPassword: ''
      },
      service: null,
      errorTitle: '',
      errorMessage: ''
    }
  },
  computed: {
    ...mapGetters({
      services: 'service/services',
      authUser: 'authUser/user'
    })
  },
  created () {
  },
  methods: {
    showModal () {
      this.$refs.errorModal.show()
    },
    hideModal () {
      this.$refs.errorModal.hide()
    },
    checkEntry () {
      this.service = null
      const index = this.services.findIndex(service => service.entryCode === this.input.entryCode)
      if (index !== -1) {
        this.service = JSON.parse(JSON.stringify(this.services[index]))
      }
      return index
    },
    registerWithService (provider) {
      return new Promise((resolve, reject) => {
        var vm = this
        var user = firebase.auth().currentUser
        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        var docRef = db.collection('users').doc(user.uid)
        docRef.get().then(function (doc) {
          if (!doc.exists) {
            var service = {}
            service[vm.service.key] = true
            var photo = user.photoURL
            if (provider === 'facebook') {
              photo = photo + '?width=512&height=512'
            }
            const payload = {
              'key': user.uid,
              'role': 'user',
              'services': service,
              'groups': {},
              'name': user.displayName,
              'email': user.email,
              'status': '',
              'icon': photo,
              'routine': [],
              'enable': true,
              'option': {},
              'createdAt': parseInt(new Date().getTime() / 1000),
              'updatedAt': parseInt(new Date().getTime() / 1000)
            }
            const batch = db.batch()
            var refuser = db.collection('users').doc(user.uid)
            batch.set(refuser, payload)

            // var refChatsRefFrom = db.collection('chats_refs').doc(vm.service.key).collection('refs').doc(user.uid)
            // batch.set(refChatsRefFrom,
            //   {
            //     'location': vm.service.chats_ref,
            //     'type': 'service',
            //     'status': 'pending',
            //     'enable': false,
            //     'createdAt': parseInt(new Date().getTime() / 1000),
            //     'updatedAt': parseInt(new Date().getTime() / 1000)
            //   }
            // )
            // var refChatsRefTo = db.collection('chats_refs').doc(user.uid).collection('refs').doc(vm.service.key)
            // batch.set(refChatsRefTo,
            //   {
            //     'location': vm.service.chats_ref,
            //     'type': 'service',
            //     'status': 'requesting',
            //     'enable': false,
            //     'createdAt': parseInt(new Date().getTime() / 1000),
            //     'updatedAt': parseInt(new Date().getTime() / 1000)
            //   }
            // )

            batch.commit().then(function () {
              var serviceRef = db.collection('services').doc(vm.service.key)
              return db.runTransaction(function (transaction) {
                return transaction.get(serviceRef).then(function (doc) {
                  if (doc.exists) {
                    var service = JSON.parse(JSON.stringify(doc.data()))
                    service.users[user.uid] = true
                    service.updatedAt = parseInt(new Date().getTime() / 1000)
                    transaction.update(serviceRef, service)
                  }
                }).then(function () {
                  resolve()
                }).catch(function (error) {
                  console.log('transaction:', error)
                  resolve()
                })
              })
              // vm.$router.go(-1)
            })
          } else {
            resolve()
          }
        })
      })
    },
    register () {
      var vm = this
      if (this.checkEntry() === -1) {
        this.errorMessage = '正しいエントリーコードを入力してください。ご不明な場合は、担当までお問い合わせください'
        this.showModal()
        return
      }
      if (this.input.username === '') {
        this.errorMessage = 'メールアドレスを入力してください'
        this.showModal()
        return
      }
      if (this.input.password !== this.input.repeatPassword) {
        this.errorMessage = 'パスワードが一致しません'
        this.showModal()
        return
      }
      if (this.input.password !== '') {
        firebase.auth().createUserWithEmailAndPassword(this.input.username, this.input.password).then(function (result) {
          vm.onLoading()
          vm.$store.dispatch('dispatch/setLoading', true)
          vm.registerWithService('password').then(() => {
            vm.$router.push('/')
            vm.$store.dispatch('register/register', true)
          })
        }).catch(function (error) {
          vm.errorMessage = error.message
          vm.showModal()
        })
      } else {
        this.errorMessage = 'パスワードをを入力してください'
        this.showModal()
      }
    },
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Register.vue